var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('partner-products-section',{attrs:{"title":_vm.$t('Buy again'),"products":_vm.products,"loading":_vm.loading}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }